"use client";

import { AnimatedBurgerIcon } from "@/components/ui/Burger";
import { ModalContent, ModalRoot, ModalTrigger, ModalViewport } from "@/components/ui/Drawer";
import { useModal } from "@/hooks/useModal";
import { useMediaQuery } from "@frend-digital/ui/hooks";
import { useUrlSearchParams } from "@frend-digital/ui/next";
import { type PropsWithChildren, useEffect } from "react";
import styles from "./Header.module.css";
import { useStateParams } from "../../../hooks/use-state-params";
export const useMobileMenu = () => {
	const modal = useModal("mobile-menu");

	return modal;
};

export const MobileMenu = ({ children }: PropsWithChildren<{}>) => {
	const matches = useMediaQuery("(max-width: 1024px)");

	const { open, setOpen } = useMobileMenu();

	const searchParams = useStateParams();

	useEffect(() => {
		if (!matches) {
			setOpen(false);
		}
	}, [matches, setOpen]);

	useEffect(() => {
		if (open) return;

		const sections = searchParams.getAll("section");
		for (const section of sections) {
			searchParams.delete("section", section);
		}
	}, [searchParams, open]);

	if (!matches)
		return (
			<>
				<AnimatedBurgerIcon
					data-state={open ? "open" : undefined}
					open={open}
					className={styles.burger}
				/>
			</>
		);

	return (
		<ModalRoot open={open} onOpenChange={setOpen}>
			<ModalTrigger asChild>
				<AnimatedBurgerIcon
					data-state={open ? "open" : undefined}
					open={open}
					className={styles.burger}
				/>
			</ModalTrigger>
			<ModalViewport className={!open ? styles.timing : ""}>
				<ModalContent className={styles.mobileMenu} data-menu-state={open ? "open" : "closed"}>
					{children}
				</ModalContent>
			</ModalViewport>
		</ModalRoot>
	);
};
